import React from 'react';
import type { CellContext } from '@tanstack/react-table';
import {
  convertCostTimePeriod,
  formatDate,
  formatDateTime,
  formatPrice,
} from '../utils';
import LongContentPopover from '../LongContentPopover/LongContentPopover';

export function renderDate<TData, TValue>(cell: CellContext<TData, TValue>) {
  const date = cell.getValue() as Date | undefined;
  return date ? formatDate(date) : 'Unknown';
}

export function formatDatetime<TData>(relative?: boolean) {
  return function cellFormatter(cell: CellContext<TData, Date>) {
    const date = cell.getValue();
    return date ? formatDateTime(date, relative) : '-';
  };
}

export function renderDatetime<TData, TValue extends Date>(relative?: boolean) {
  const formatter = formatDatetime<TData>(relative);
  return function cellRenderer(cell: CellContext<TData, TValue>) {
    return <LongContentPopover>{formatter(cell)}</LongContentPopover>;
  };
}

export function formatPriceCell<TData>(cell: CellContext<TData, number>) {
  const price = cell.getValue() as number | undefined;
  if (price === undefined) return 'Unknown';
  const normalizedPrice = convertCostTimePeriod(
    { value: price, period: 'hourly' },
    'yearly',
  );
  return formatPrice(normalizedPrice);
}

export function renderPrice<TData, TValue extends number>(
  cell: CellContext<TData, TValue>,
) {
  const formatted = formatPriceCell<TData>(cell);
  return <LongContentPopover>{formatted}</LongContentPopover>;
}

export function renderLargeNumber<TData, TValue>(
  cell: CellContext<TData, TValue>,
) {
  const number = cell.getValue() as number | undefined;
  if (number === undefined) {
    <LongContentPopover>Unknown</LongContentPopover>;
  }
  return (
    <LongContentPopover>
      {(number as number).toLocaleString()}
    </LongContentPopover>
  );
}

export function renderLongContent<TData, TValue>(
  cell: CellContext<TData, TValue>,
) {
  return (
    <LongContentPopover>
      {cell.getValue() as unknown as React.ReactNode}
    </LongContentPopover>
  );
}
